<template>
    <div class="loginContainer">
        <div class="logoMurprotect">
            <img class="backIcon" style="visibility: hidden" src="/images/icn_back.png" @click="$router.push('home')"/>
            <img src="/images/logo_murprotect.png"/>
        </div>
        <div class="formContainer">

            <div class="logoHome">
                <img src="/images/login/icono.png"/>
            </div>
            <div class="form">
                <div class="formContent">
                    <div class="formElement">
                        <input class="emailInput" :placeholder="$t('login.email')" type="text" v-model="email"/>
                    </div>
                    <div class="formElement">
                        <input class="passwordInput" :placeholder="$t('login.password')" type="password"
                               v-model="password"/>
                    </div>
                </div>

                <!--<span class="rememberPassword" @click="toggleRememberPass">-->
                <!--<img v-if="rememberPassword" src="/images/login/icn_check_on.png"/>-->
                <!--<img v-else src="/images/login/icn_check_off.png"/>-->
                <!--{{ $t("login.remember") }}-->
                <!--</span>-->

                <!--<span class="recoverPassword">-->
                <!--<router-link to="/recover">{{ $t("login.forgot")}}</router-link>-->
                <!--</span>-->

                <p class="error" v-if="error">{{ $t("login.error") }}</p>

                <a class="button sendButton is-primary"
                   :disabled="email.length === 0  || password.length === 0 || !checkEmail(email)"
                   v-on:click="signIn">
                    <span>{{ $t("login.send") }}</span>
                    <img src="/images/login/icn_enviar.png"/>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
    import firebase from 'firebase/app'
    import {EventBus} from "../../util/event-bus";

    export default {
        name: 'login',
        data: function () {
            return {
                email: '',
                password: '',
                rememberPassword: false,
                error: false,
            }
        },
        methods: {

            checkEmail: function (email) {
                // eslint-disable-next-line
                let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(String(email).toLowerCase());
            },

            signIn: function () {
                this.error = false;

                firebase.auth().signInWithEmailAndPassword(this.email, this.password).then(
                    (auth) => {
                        let user = auth.user;

                        //CHECK VERSION
                        this.$store.dispatch('init', user).then(() => {
                            this.$router.push('/home');
                        });
                    },
                    () => {
                        this.error = true;
                    }
                );
            },
            toggleRememberPass: function () {
                this.rememberPassword = !this.rememberPassword;
            }
        }
    }
</script>

<style lang="scss" scoped>

    #app {

        .loginContainer {
            min-height: 100vh;
            background-color: #e3e3e3;

            .formContainer {
                width: 25rem;
                margin: 0 auto;

                .logoHome {
                    width: 20%;
                    margin: 0 auto;
                }

                .form {
                    margin: 0 auto;
                    padding: 2vw;
                    width: 100%;

                    .formContent {

                        .formElement {
                            margin: 1rem 0;

                            input {
                                padding: 8px;
                                display: block;
                                border: none;
                                border-radius: 10px;
                                width: 100%;
                                height: 4rem;
                                transition: 0.2s ease-in-out border;
                                font-size: 1.2rem;
                                color: #9c9ca8;
                            }

                            .emailInput {
                                background: white url("/images/login/icn_user.png") no-repeat scroll 5% 50%;
                                padding-left: 15%;
                                background-size: 8%;
                            }
                            .passwordInput {
                                background: white url("/images/login/icn_pass.png") no-repeat scroll 5% 50%;
                                padding-left: 15%;
                                background-size: 8%;
                            }

                        }
                        .error {
                            font-size: 0.8rem;
                            color: #a12d2d;
                            margin-bottom: 2em;
                        }
                    }

                    .sendButton {
                        margin-top: 10%;
                        border-radius: 1vh;
                        border: none;
                        color: #ffffff;
                        font-size: 1.3rem;
                        cursor: pointer;
                        transition: 0.2s ease-in-out background;

                        img {
                            position: relative;
                            left: 10%;
                            width: 15%;
                        }
                    }

                    .rememberPassword {
                        float: left;
                        cursor: pointer;
                        color: #666666;
                        font-size: smaller;

                        img {
                            width: 10%;
                        }
                    }
                    .recoverPassword {
                        float: right;
                        cursor: pointer;
                        font-size: smaller;
                        a {
                            color: #666666;
                        }
                    }
                }
            }
        }
    }

</style>
